// extracted by mini-css-extract-plugin
export default {"App":"Layout_App__GOAWF","main":"Layout_main__g5v6s"};